import ProberEvent from './ProberEvent'
import {PROBER_EVENT_ACTION} from './ProberEventTypes'

export default class ActionEvent extends ProberEvent {
  constructor(category: string, action: string, data?: any | null) {
    super(
      Object.assign(
        {},
        {
          category,
          action,
        },
        data
      )
    )
    this.data.type = PROBER_EVENT_ACTION
  }

  getInteractionName() {
    return `${this.data.category}:${this.data.action}`
  }
}
